<template>
  <div class="utility-card" :class="variantClass">
    <div class="utility-card-icon">
      <i :class="icon" />
    </div>
    <div class="utility-card-body">
      <h6 class="utility-title">
        {{ title }}
      </h6>
      <p class="utility-description">
        {{ description }}
      </p>
    </div>
    <div class="utility-card-footer">
      <b-button
        variant="light"
        size="sm"
        class="utility-btn"
      >
        {{ $t('general.open', 'Open') }}
        <i class="fas fa-arrow-right ml-2" />
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UtilityCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: 'fas fa-tools',
    },
    variant: {
      type: String,
      default: 'info',
      validator: (value) => ['info', 'warning', 'danger', 'success'].includes(value),
    },
  },
  computed: {
    variantClass() {
      return `utility-${this.variant}`
    },
  },
}
</script>

<style scoped>
.utility-card {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  border-top: 4px solid #ccc;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.utility-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.utility-info {
  border-top-color: #17a2b8;
}

.utility-warning {
  border-top-color: #ffc107;
}

.utility-danger {
  border-top-color: #dc3545;
}

.utility-success {
  border-top-color: #28a745;
}

.utility-card-icon {
  font-size: 2rem;
  color: #0066cc;
  margin-bottom: 15px;
}

.utility-info .utility-card-icon {
  color: #17a2b8;
}

.utility-warning .utility-card-icon {
  color: #ffc107;
}

.utility-danger .utility-card-icon {
  color: #dc3545;
}

.utility-success .utility-card-icon {
  color: #28a745;
}

.utility-card-body {
  flex-grow: 1;
  margin-bottom: 15px;
}

.utility-title {
  color: #333;
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 1rem;
}

.utility-description {
  color: #666;
  font-size: 0.9rem;
  margin: 0;
}

.utility-card-footer {
  border-top: 1px solid #e9ecef;
  padding-top: 12px;
}

.utility-btn {
  width: 100%;
  color: #0066cc;
  border-color: #0066cc;
  transition: all 0.3s ease;
}

.utility-btn:hover {
  background-color: #0066cc;
  color: #fff;
  border-color: #0066cc;
}

.utility-info .utility-btn {
  color: #17a2b8;
  border-color: #17a2b8;
}

.utility-info .utility-btn:hover {
  background-color: #17a2b8;
  color: #fff;
  border-color: #17a2b8;
}

.utility-warning .utility-btn {
  color: #ffc107;
  border-color: #ffc107;
}

.utility-warning .utility-btn:hover {
  background-color: #ffc107;
  color: #000;
  border-color: #ffc107;
}

.utility-danger .utility-btn {
  color: #dc3545;
  border-color: #dc3545;
}

.utility-danger .utility-btn:hover {
  background-color: #dc3545;
  color: #fff;
  border-color: #dc3545;
}

.utility-success .utility-btn {
  color: #28a745;
  border-color: #28a745;
}

.utility-success .utility-btn:hover {
  background-color: #28a745;
  color: #fff;
  border-color: #28a745;
}
</style>
